import React, { lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

const LoginPage = lazy(() => import('../admin/pages/LoginPage'));
const AdminLayout = lazy(() => import('../admin/components/AdminLayout'));
const DashboardPage = lazy(() => import('../admin/pages/DashboardPage'));
const InscriptionsPage = lazy(() => import('../admin/pages/InscriptionsPage'));
const EventsPage = lazy(() => import('../admin/pages/EventsPage'));
const BoardPage = lazy(() => import('../admin/pages/BoardPage'));
const SponsorsPage = lazy(() => import('../admin/pages/SponsorsPage'));
const MunicipalitiesPage = lazy(() => import('../admin/pages/MunicipalitiesPage'));
const ContentPage = lazy(() => import('../admin/pages/ContentPage'));
const LogsPage = lazy(() => import('../admin/pages/LogsPage'));
const SettingsPage = lazy(() => import('../admin/pages/SettingsPage'));
const EmailPage = lazy(() => import('../admin/pages/EmailPage'));
const CertificatesPage = lazy(() => import('../admin/pages/CertificatesPage'));
const MemberCardsPage = lazy(() => import('../admin/pages/MemberCardsPage'));
const AdminMembersPage = lazy(() => import('../admin/pages/AdminMembersPage'));
const AdminPaymentsPage = lazy(() => import('../admin/pages/AdminPaymentsPage'));
const SchedulePage = lazy(() => import('../admin/pages/SchedulePage'));
const ProtectedRoute = lazy(() =>
  import('../admin/components/ProtectedRoute').then(module => ({ default: module.ProtectedRoute }))
);

export function AdminRoutes() {
  return (
    <Routes>
      <Route path="login" element={<LoginPage />} />
      <Route
        path="*"
        element={
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="inscriptions" element={<InscriptionsPage />} />
        <Route path="events" element={<EventsPage />} />
        <Route path="schedule" element={<SchedulePage />} />
        <Route path="sponsors" element={<SponsorsPage />} />
        <Route path="municipalities" element={<MunicipalitiesPage />} />
        <Route path="content" element={<ContentPage />} />
        <Route path="board" element={<BoardPage />} />
        <Route path="certificates" element={<CertificatesPage />} />
        <Route path="member-cards" element={<MemberCardsPage />} />
        <Route path="members" element={<AdminMembersPage />} />
        <Route path="payments" element={<AdminPaymentsPage />} />
        <Route path="logs" element={<LogsPage />} />
        <Route path="emails" element={<EmailPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="*" element={<Navigate to="dashboard" replace />} />
      </Route>
    </Routes>
  );
}

